export class Countries{
      "countryCode3a": string
      "countryGaliaLabel": string
      "countryFlag": string
      "countryIsoCode": string
      "countryFullName": string
      "countryCode": string
      "countryStatus": boolean
      "countryName": string
      "countryCode3n": string
      "rowId": string
}

export class CountriesList {
  "countries": Countries[]
}

export class Cities{
    "countryCode": string
    "latitude": string
    "name": string
    "active": boolean
    "countryName": string
    "countryId": string
    "rowId": string
    "longitude": string
}

export class CitiesList {
  "cities": Cities[]
}